import type { AdminRegistryHold } from '@/types'

export const REGISTRY_HOLD_KEYS: Record<AdminRegistryHold, string> = {
  not_held: 'dashboard.admin.domains.suspension.hold.notHeld',
  held: 'dashboard.admin.domains.suspension.hold.held',
  failed: 'dashboard.admin.domains.suspension.hold.failed'
}
